import { createSlice } from '@reduxjs/toolkit';

export const pageSlice = createSlice({
  name: 'page',
  initialState: {
    type: 'default',
    isMasterPlanDetail: false,
  },
  reducers: {
    setPageType: (state, action) => {
      state.type = action.payload;
      state.isMasterPlanDetail = action.payload === 'masterPlanDetail';
    },
  },
});

// ✅ ПРАВИЛЬНО: экспортируем action creator
export const { setPageType } = pageSlice.actions;

// ✅ ПРАВИЛЬНО: экспортируем reducer
export default pageSlice.reducer;
